import Text from '@components/Text';
import { HTMLAttributes, ReactNode } from 'react';

import CheckedIcon from './CheckedIcon';
import DefaultIcon from './DefaultIcon';
import styles from './styles.module.scss';

export interface Props extends HTMLAttributes<HTMLDivElement>{
    isChecked?: boolean;
    toggleCheckbox?: () => void;
    children?: ReactNode;
    disabled?: boolean;
}

function Checkbox(props: Props) {
  const {
    isChecked, toggleCheckbox, children, className, disabled, ...rest
  } = props;
  return (<div aria-label='checkbox'
               aria-disabled={disabled}
               className={`${styles.container} ${className}`}
                       onClick={(e) => {
                         e.preventDefault();
                         e.stopPropagation();
                         toggleCheckbox?.();
                       }}
                       {...rest}>
      {isChecked ? <CheckedIcon/> : <DefaultIcon/>}
        <Text as='div' className={styles.text}>
            {children}
        </Text>
    </div>);
}

export default Checkbox;
